import { useEffect, useState } from 'react'
import { X } from 'lucide-react'

import { Button } from '@/components/ui/button'

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {string} [props.initialNotes]
 * @param {boolean} props.submitting
 * @param {(notes: string) => Promise<void>} props.onSave
 */
export function PosTicketNoteModal({
  open,
  onClose,
  initialNotes = '',
  submitting,
  onSave,
}) {
  const [notes, setNotes] = useState(initialNotes)

  useEffect(() => {
    if (open) {
      setNotes(initialNotes ?? '')
    }
  }, [initialNotes, open])

  if (!open) return null

  return (
    <div className="pos-v2-modal-backdrop" role="presentation">
      <div className="pos-v2-modal pos-v2-modal--narrow" role="dialog" aria-label="Ticket note">
        <div className="flex items-center justify-between border-b border-[#E5E7EB] px-4 py-3">
          <h2 className="text-sm font-bold text-slate-900">Ticket note</h2>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-md text-slate-500 hover:bg-slate-100"
            aria-label="Close"
          >
            <X className="h-4 w-4" aria-hidden />
          </button>
        </div>

        <div className="p-4">
          <textarea
            value={notes}
            onChange={(event) => setNotes(event.target.value)}
            rows={4}
            disabled={submitting}
            className="pos-v2-drawer-input min-h-[100px] w-full resize-none"
            placeholder="Add a note for this ticket (visible on service slips)"
          />
        </div>

        <div className="flex gap-2 border-t border-[#E5E7EB] p-4">
          <Button type="button" variant="outline" className="min-h-[44px]" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button
            type="button"
            className="min-h-[44px] flex-1"
            disabled={submitting}
            onClick={async () => {
              await onSave(notes.trim())
              onClose()
            }}
          >
            {submitting ? 'Saving…' : 'Save note'}
          </Button>
        </div>
      </div>
    </div>
  )
}
